module.exports = ".flex-btn {\n    cursor: pointer;\n    margin-left: 16px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/solar/common/guidance/guidance.component.css
// module id = ./src/app/solar/common/guidance/guidance.component.css
// module chunks = main